{
  "login": {
    "subtitle": "Espace Administration",
    "email_label": "Adresse email",
    "email_placeholder": "votre.email@djayma.com",
    "password_label": "Mot de passe",
    "password_placeholder": "Votre mot de passe",
    "submit": "Se connecter",
    "submitting": "Connexion en cours...",
    "footer": "Accès réservé aux gérants Djayma",
    "error_invalid": "Email ou mot de passe incorrect.",
    "error_network": "Erreur de connexion. Veuillez réessayer.",
    "error_rate_limit": "Trop de tentatives. Veuillez patienter.",
    "error_unauthorized": "Ce compte n'a pas accès à l'administration Djayma."
  },
  "nav": {
    "sections": {
      "commerce": "Jaay-jënd",
      "payments": "Fey yi",
      "delivery": "Yóbbal",
      "b2b": "B2B",
      "crm": "CRM",
      "marketing": "Marketing",
      "finance": "Xaalis",
      "operations": "Liggéey yi",
      "settings": "Paramètres",
      "analytique": "Analytique",
      "administration": "Administration",
      "gestion": "Gestion",
      "croissance": "Croissance",
      "principal": "Principal",
      "yoboulmako": "Yoboulmako"
    },
    "dashboard": "Tablo bord",
    "orders": "Komand yi",
    "products": "Njënd yi",
    "categories": "Wàll yi",
    "inventory": "Stok",
    "stock_alerts": "Xamle stok",
    "notifications": "Yéegal yi",
    "payment_manager": "Saytu fey yi",
    "reconciliation": "Jublanti",
    "refunds": "Fey delloo yi",
    "disputes": "Tuxum yi",
    "daily_cash": "Rapport kees",
    "delivery_board": "Tablo yóbbal",
    "drivers": "Sooféer yi",
    "route_optimization": "Yoonu yóbbal",
    "live_tracking": "Topp ci kanam",
    "yango": "Yango",
    "delivery_zones": "Zon yi",
    "delivery_slots": "Waxtu yi",
    "depots": "Dépôt yi",
    "delivery_performance": "Jëf-jëf",
    "b2b_customers": "Kiliyaan B2B",
    "b2b_price_lists": "Njëg yi",
    "b2b_credit": "Karedit yi",
    "b2b_approvals": "Nangu yi",
    "b2b_import": "Dugg ci yépp",
    "b2b_invoices": "Faktiir B2B",
    "b2b_aging": "Rapport borrom",
    "suppliers": "Furniseer yi",
    "b2b_volume_discounts": "Wàcc njëg",
    "b2b_reps": "Komersiyaal yi",
    "clients_360": "Kiliyaan 360°",
    "segments": "Segmantasion",
    "loyalty": "Gëm-gëm",
    "whatsapp": "WhatsApp",
    "sms": "SMS",
    "feedback": "Feytaal",
    "abandoned_carts": "Paañe yu des",
    "clv": "Njariñ kiliyaan",
    "referrals": "Yónne",
    "communications": "Waxtaan yi",
    "promotions": "Promosion yi",
    "coupons": "Kupong yi",
    "flash_sales": "Jaay gaaw",
    "bundles": "Pake yi",
    "banners": "Bàneer yi",
    "newsletter": "Letër",
    "seasonal": "Kalàndiriye",
    "stacking_rules": "Yoonu jubal",
    "promo_analytics": "Statistik promo",
    "tracking_links": "Lien sosiyaal",
    "revenue": "Ndey-jënd",
    "tva": "TVA",
    "margins": "Maars yi",
    "expenses": "Dépaans yi",
    "invoices": "Faktiir yi",
    "cashflow": "Yoonu xaalis",
    "sage_export": "Export Sage",
    "powerbi": "Power BI",
    "reports": "Rapport yi",
    "daily_pnl": "P&L bes-bes",
    "admin_users": "Jëfandikukat admin",
    "roles": "Rool ak sañ-sañ",
    "audit_log": "Kayit audit",
    "tasks": "Liggéey yi",
    "shifts": "Planning",
    "agent_performance": "Jëf-jëf azan yi",
    "announcements": "Yéegale yi",
    "sla": "SLA",
    "incidents": "Insidàn yi",
    "messages": "Bataaxal yi",
    "clients": "Kiliyaan yi (CRM)",
    "finances": "Xaalis",
    "logistics": "Logistik",
    "returns": "Retuur yi",
    "settings": "Parameetar yi",
    "lancement": "Dëkk Djayma",
    "yoboulmako_dashboard": "Doxalinu Yoboulmako",
    "yoboulmako_livraisons": "Yóbbal bu dëkk",
    "yoboulmako_clients": "Kiliyaan yi",
    "yoboulmako_facturation": "Faktuur yi",
    "yoboulmako_parametres": "Parameetar yi",
    "einvoice": "Facturation électronique",
    "anomaly_detection": "Détection anomalies",
    "modules": "Modules",
    "system_health": "Santé système",
    "marketing_hub": "Marketing",
    "ai_dashboard": "Intelligence IA",
    "data_export": "Export données",
    "replenishment": "Réapprovisionnement",
    "demand_forecast": "Prévision demande",
    "integrations_page": "Intégrations",
    "api_keys": "Clés API",
    "analytics_search": "Recherches",
    "analytics_intent": "Intentions",
    "model_monitor": "Suivi modèles",
    "backup": "Sauvegardes",
    "enterprise": "Entreprise",
    "churn_prediction": "Prédiction attrition",
    "smart_pricing": "Tarification intelligente",
    "sales_insights": "Analyses ventes",
    "finance_hub": "Finance",
    "analytics_overview": "Vue d'ensemble",
    "webhooks": "Webhooks",
    "analytics_trending": "Tendances",
    "crm": "CRM",
    "analytics_funnel": "Entonnoir",
    "b2b_hub": "B2B",
    "operations_hub": "Opérations",
    "sentiment_analysis": "Analyse sentiments",
    "recommendations": "Recommandations",
    "privacy": "Vie privée",
    "gdpr": "RGPD / Vie privée",
    "error_dashboard": "Erreurs Storefront",
    "feature_flags": "Feature Flags",
    "account_deletions": "Suppressions comptes",
    "content": "Contenu"
  },
  "header": {
    "title": "Njàngat Djayma",
    "admin_label": "Administrateur"
  },
  "dashboard": {
    "title": "Tablo bord",
    "welcome": "Dalal jàmm ci espas njàngat bi",
    "error": "Mënuñu yéegal xam-xam yi ci tablo bord bi. Jéemal ko.",
    "kpi": {
      "revenue_today": "Xaalis bi tey",
      "orders_today": "Komand yi tey",
      "aov": "Tollu warugar",
      "pending_payments": "Fey yi ci xaar"
    },
    "charts": {
      "revenue_title": "Yoonu xaalis bi",
      "orders_by_status_title": "Komand yi ci yoonu",
      "top_products_title": "5 njënd yi gëna jënd",
      "region_revenue_title": "Xaalis ci zon yi",
      "revenue_label": "Xaalis",
      "orders_label": "Komand yi",
      "no_data": "Amul xam-xam ci waxtu bii"
    }
  },
  "actions": {
    "save": "Denc",
    "cancel": "Neenal",
    "delete": "Far",
    "edit": "Soppi",
    "search": "Seet",
    "filter": "Tànn",
    "export": "Génne",
    "create": "Sos",
    "back": "Dellu",
    "confirm": "Dëggal",
    "close": "Tëj"
  },
  "status": {
    "active": "Aktif",
    "inactive": "Taxawul",
    "pending": "Ci xaar",
    "approved": "Nangu na",
    "rejected": "Bañ na",
    "processing": "Ci kanam",
    "completed": "Jeex na",
    "cancelled": "Neenal na"
  },
  "placeholder": {
    "coming_soon": "Modul bi ci liggéey la",
    "coming_soon_description": "Modul bii dina am ci kanam."
  },
  "order_detail": {
    "title": "Komand {{ref}}",
    "back_to_orders": "Dellu ci komand yi",
    "created_at": "Sos ci",
    "customer": "Kiliyaan",
    "phone": "Telefon",
    "email": "Imel",
    "delivery_address": "Adres yóbbal",
    "region": "Réew-réew",
    "payment_method": "Yoonu fey",
    "subtotal_ht": "Tollu HT",
    "tax": "TVA",
    "delivery_fee": "Yóbbal",
    "total_ttc": "Tollu TTC",
    "items": "Yeneen",
    "col_product": "Prodwi",
    "col_sku": "SKU",
    "col_qty": "Toll",
    "col_unit_price": "Prix yi",
    "col_line_total": "Tollu rëdd",
    "timeline": "Taariix",
    "notes": "Not yi",
    "add_note": "Yokk not",
    "note_placeholder": "Bind sa not...",
    "note_submit": "Yónne",
    "note_empty": "Amul not ci komand bii.",
    "actions_title": "Jëf yi",
    "no_actions_available": "Amul benn jëf ci komand bii.",
    "confirm_order": "Dëggal",
    "cancel_order": "Neenal",
    "process_order": "Tambali defar",
    "ship_order": "Yónne",
    "deliver_order": "Jox na",
    "retry_payment": "Jéemaat fey",
    "print_delivery_slip": "Móol fiche yóbbal",
    "initiate_refund": "Tambali fey delloo",
    "confirm_status_title": "Dëggal soppi yoonu bi",
    "confirm_status_message": "Danga bëgg soppi yoonu komand bi \"{{status}}\"?",
    "confirm_status_yes": "Dëggal",
    "confirm_status_no": "Neenal",
    "error_loading": "Mënuñu yéegal komand bi.",
    "error_status_update": "Mënuñu soppi yoonu bi.",
    "error_add_note": "Mënuñu yokk not bi.",
    "success_status_update": "Yoonu bi soppi na bu baax.",
    "success_note_added": "Not bi yokk na.",
    "not_found": "Komand bi gis-ñu-ko",
    "not_found_description": "Komand bi ñu laaj amul walla fey nañu ko.",
    "no_items": "Amul yeneen",
    "delivery": "Yóbbal",
    "driver": "Ofeeru",
    "delivery_status": "Yoonu yóbbal",
    "payments": "Fey yi",
    "payment_ref": "Ref.",
    "payment_amount": "Tollu",
    "payment_status": "Yoonu",
    "payment_date": "Bés"
  },
  "bulk_orders": {
    "confirm": "Dëggal",
    "ship": "Yóbbi",
    "deliver": "Tekki jëlaat",
    "cancel": "Nëbb",
    "confirm_title": "Dëggalug",
    "confirm_dialog": "Ndax dëgg nga bëgg {{action}} {{count}} komand yi?",
    "processing": "Ci anam…",
    "success": "{{count}} komand yi yeesal nañu",
    "all_failed": "Amul komand bu yeesal. Saytul yoonu yi.",
    "partial_success": "{{updated}} yeesal na. {{failed}} jafe-jafe.",
    "error": "Jafe-jafe: {{message}}",
    "undo": "Delloo",
    "undone": "Yeesal bi dellusi na",
    "undo_failed": "Manula delloo yeesal bi"
  },
  "returns": {
    "col_order": "Komand",
    "col_date": "Bés",
    "col_reason": "Ngirte",
    "col_status": "Yoonu",
    "col_refund": "Fey delloo",
    "col_actions": "Jëf yi",
    "filter_all": "Yoonu yépp",
    "empty": "Amul ñaane retuur",
    "error_loading": "Mënuñu yéegal retuur yi.",
    "error_generic": "Am na njuumte. Jéemal ko.",
    "action_review": "Saytu",
    "action_view": "Xool",
    "modal_title": "Saytu retuur bi",
    "action_approve": "Nangu",
    "action_reject": "Bañ",
    "refund_amount_label": "Tollu fey delloo (FCFA)",
    "refund_method_label": "Yoonu fey delloo",
    "admin_notes_label": "Not biir (du waajib)",
    "admin_notes_placeholder": "Bataaxal bu ekip bi rekk mën gis...",
    "pagination_info": "Xàtt {{page}} / {{total_pages}} — {{total}} ñaane(s)",
    "prev_page": "Xàtt bi ci ginnaaw",
    "next_page": "Xàtt bi ci kanam"
  },
  "categories": {
    "page_title": "Mbooloo yi",
    "page_description": "Tegal say yeneen ci mbooloo ak mbooloo-ndaw (3 capa max).",
    "add": "Mbooloo bu bees",
    "create_title": "Sos mbooloo",
    "edit_title": "Soppi mbooloo bi",
    "empty": "Amul mbooloo",
    "empty_hint": "Sosël sa mbooloo bu njëk ngir tegal say yeneen.",
    "error_loading": "Manula yeb mbooloo yi.",
    "expand": "Ubbi",
    "collapse": "Tëj",
    "add_child": "Yokk mbooloo-ndaw",
    "product_count_one": "{{count}} yeneen",
    "product_count_other": "{{count}} yeneen yi",
    "product_count": "{{count}} yeneen(s)",
    "field_name_fr": "Tur (Français)",
    "field_name_wo": "Tur (Wolof)",
    "field_name_en": "Tur (Anglais)",
    "field_slug": "Slug",
    "field_parent": "Mbooloo bu mag",
    "field_image": "Nataal (URL)",
    "field_active": "Mbooloo bu dox",
    "placeholder_name_fr": "Misaal: Meew",
    "placeholder_name_wo": "Misaal: Meew",
    "placeholder_name_en": "Misaal: Dairy products",
    "no_parent": "— Keneen (dëkk) —",
    "select_parent": "Tann mbooloo...",
    "delete_title": "Far mbooloo bi",
    "delete_confirm": "Bëgg nga far « {{name}} » ?",
    "delete_has_products": "Mbooloo bii am na {{count}} yeneen. Dinañu ko génne.",
    "delete_has_children": "Mbooloo bii am na {{count}} mbooloo-ndaw. Lu la neexe?",
    "move_children_to": "Toxal mbooloo-ndaw yi ci...",
    "delete_all_children": "Far lépp (mbooloo + mbooloo-ndaw yi)",
    "deleting": "Yàqu..."
  },
  "images": {
    "image": "Nataal",
    "primary": "Bopp",
    "is_primary": "Nataal bu njëkk",
    "set_primary": "Def ko nataal bu njëkk",
    "delete": "Far",
    "confirm_delete": "Dëggal faru",
    "deleted": "Nataal bi farñu ko",
    "add": "Yokk",
    "upload_success": "Nataal bi yonnee na bu baax",
    "max_reached": "Maximum {{max}} nataal ci benn product",
    "count": "{{current}} / {{max}} nataal",
    "empty_title": "Amul nataal",
    "empty_description": "Bësal ngir yokk nataal ci product bi",
    "select_files": "Tann dossier yi",
    "invalid_type": "Type bu dossier bi du jàpp. Format yi: JPEG, PNG, WebP, AVIF.",
    "file_too_large": "Dossier bi rëy na lu gën {{max}} Mo",
    "upload_error": "Njuumte ci yonnee nataal bi",
    "reorder_error": "Njuumte ci weccit tërinu nataal yi"
  },
  "stock_alerts": {
    "title": "Yoonu xëlaat ci stock bi",
    "add_rule": "Yokk yoon",
    "create_rule_title": "Yoon bu bees bu xëlaat",
    "edit_rule_title": "Soppi yoonu xëlaat bi",
    "col_scope": "Product / Wàll",
    "col_threshold": "Tollu",
    "col_channels": "Yoon yi",
    "col_auto_reorder": "Commande auto",
    "col_status": "Alal",
    "col_actions": "Jëf yi",
    "auto_reorder_on": "Auto",
    "field_scope": "Ci lan",
    "scope_product": "Product",
    "scope_category": "Wàll",
    "field_product": "Product",
    "product_placeholder": "ID bu product bi",
    "field_category": "Wàll",
    "category_placeholder": "ID bu wàll bi",
    "field_threshold": "Tollu stock bi gën a ndaw",
    "field_channels": "Yoonu xëlaat yi",
    "field_auto_reorder": "Commande auto",
    "auto_reorder_tooltip": "Sos ci sa bopp bon de commande",
    "field_active": "Yoon bi dox na",
    "confirm_delete": "Dëgg nga bëgg faru yoonu xëlaat bii?",
    "error_loading": "Mënul a jële yoonu xëlaat yi.",
    "empty_title": "Amul yoonu xëlaat",
    "empty_description": "Sos sa yoon bu njëk ngir xam bu stock bi daw."
  },
  "orders": {
    "filter_region": "Réew-réew",
    "bulk_confirm": "Dëggal",
    "action_view": "Seet komand bi",
    "subtitle": "Toppal komand yi say kiliyaan",
    "col_actions": "Jëf",
    "empty": "Amul komand.",
    "col_amount": "Tollu TTC",
    "col_date": "Bes",
    "col_client": "Kiliyaan",
    "title": "Komand yi",
    "col_reference": "Référans",
    "search_placeholder": "Seet ci référans, kiliyaan, telefon...",
    "col_status": "Yoon",
    "col_payment": "Fey",
    "error_loading": "Mënuñu yéegal komand yi.",
    "error_hint": "Xoolal sa réseau ci lee jéemal ko.",
    "retry": "Jéemal ko",
    "clear_filters": "Far tànn yi",
    "result_count_one": "{{count}} komand gis na",
    "result_count_other": "{{count}} komand gis na",
    "bulk_cancel": "Neenal",
    "bulk_confirmed_one": "{{count}} komand dëggal na",
    "bulk_confirmed_other": "{{count}} komand dëggal na",
    "bulk_cancelled_one": "{{count}} komand neenal na",
    "bulk_cancelled_other": "{{count}} komand neenal na",
    "bulk_partial_failure_one": "{{count}} komand mënul soppi",
    "bulk_partial_failure_other": "{{count}} komand mënuñu soppi",
    "bulk_error": "Mënuñu soppi komand yi.",
    "filter_status": "Yoon",
    "filter_payment": "Fey",
    "action_view_short": "Seet",
    "status": {
      "pending": "Ci xaar",
      "confirmed": "Dëggal na",
      "processing": "Ci kanam",
      "shipped": "Yóbbu na",
      "delivered": "Yóbbal na",
      "cancelled": "Neenal na",
      "cancelled_timeout": "Neenal (waxtu jeex)",
      "payment_failed": "Fey bi mënul"
    },
    "payment_method": {
      "wave": "Wave",
      "orange_money": "Orange Money",
      "carte": "Kart bankeer",
      "especes": "Xaalis ci loxo",
      "virement": "Virement"
    }
  },
  "products": {
    "stock": {
      "drawer_title": "Ajustement du stock",
      "current_stock": "Stock actuel",
      "threshold": "Seuil d'alerte",
      "threshold_default": "Seuil : {{value}} (défaut)",
      "threshold_custom": "Seuil : {{value}} (personnalisé)",
      "direction_reception": "Réception (+)",
      "direction_sortie": "Sortie (-)",
      "direction_correction": "Correction (+/-)",
      "quantity": "Quantité",
      "reason": "Motif",
      "reason_restock": "Réapprovisionnement",
      "reason_sale": "Vente",
      "reason_return": "Retour",
      "reason_adjustment": "Ajustement",
      "notes": "Notes",
      "notes_required": "Notes obligatoires pour les ajustements",
      "preview": "{{from}} → {{to}} ({{delta}})",
      "confirm": "Confirmer l'ajustement",
      "success": "Stock mis à jour avec succès",
      "error_insufficient": "Stock insuffisant pour cette opération",
      "history_title": "Historique des mouvements",
      "history_empty": "Aucun mouvement enregistré",
      "history_full_link": "Voir l'historique complet",
      "history_filter_reason": "Filtrer par motif",
      "history_filter_date": "Filtrer par date"
    },
    "conflict": {
      "title": "Conflit de version",
      "message": "Le stock a été modifié par {{actor}} il y a {{time}}.",
      "your_stock": "Stock quand vous avez ouvert",
      "current_stock": "Stock actuel",
      "your_change": "Votre changement",
      "option_apply": "Appliquer mon {{delta}} au nouveau stock → {{result}}",
      "option_keep": "Garder le nouveau stock ({{current}}, abandonner mon changement)",
      "option_cancel": "Annuler",
      "apply_choice": "Appliquer mon choix"
    },
    "bulk": {
      "selected": "{{count}} produit(s) sélectionné(s)",
      "deselect": "Désélectionner",
      "select_all_page": "Tous les {{count}} produits de cette page sont sélectionnés.",
      "select_all_filtered": "Sélectionner les {{count}} produits filtrés",
      "activate": "Activer",
      "deactivate": "Désactiver",
      "price": "Prix",
      "category": "Catégorie",
      "threshold": "Seuil bas",
      "export_csv": "Exporter CSV",
      "delete": "Supprimer",
      "confirm_activate": "Activer {{count}} produit(s)",
      "confirm_deactivate": "Désactiver {{count}} produit(s)",
      "confirm_delete": "Supprimer {{count}} produit(s)",
      "typed_confirm_prompt": "Pour confirmer, tapez le nombre exact :",
      "typed_confirm_warning": "Cette action peut être annulée sous 5 secondes.",
      "price_mode_absolute": "Prix absolu",
      "price_mode_percent": "Pourcentage",
      "price_preview_old": "Ancien prix",
      "price_preview_new": "Nouveau prix",
      "price_reason": "Motif du changement de prix",
      "category_select": "Nouvelle catégorie",
      "threshold_input": "Nouveau seuil",
      "threshold_reset": "Réinitialiser au défaut",
      "pending_approval": "En attente d'approbation par la Direction",
      "undo_toast": "Annuler ({{seconds}}s)",
      "undo_success": "Action annulée"
    },
    "command_palette": {
      "placeholder": "Rechercher un produit ou une action...",
      "adjust_stock": "Ajuster le stock de...",
      "mark_out": "Marquer en rupture...",
      "export_view": "Exporter la vue actuelle",
      "new_product": "Nouveau produit",
      "import_csv": "Importer CSV",
      "stock_alerts": "Aperçu des alertes stock",
      "pending_approvals": "Voir les approbations en attente",
      "no_results": "Aucun résultat"
    },
    "keyboard": {
      "cheatsheet_title": "Raccourcis clavier",
      "nav_up": "Ligne précédente",
      "nav_down": "Ligne suivante",
      "toggle_select": "Sélectionner / désélectionner",
      "select_all": "Tout sélectionner (page)",
      "clear": "Annuler sélection / fermer",
      "edit": "Modifier le produit",
      "stock_drawer": "Ouvrir le tiroir stock",
      "command_palette": "Palette de commandes",
      "focus_search": "Focus sur la recherche",
      "show_shortcuts": "Afficher les raccourcis"
    },
    "alerts": {
      "title": "Alertes stock",
      "out_of_stock": "en rupture",
      "low_stock": "stock bas",
      "view_all": "Voir tous les produits en alerte"
    },
    "approvals": {
      "title": "Approbations en attente",
      "empty": "Aucune approbation en attente",
      "approve": "Approuver",
      "reject": "Rejeter",
      "reject_reason": "Motif du rejet",
      "approved_success": "Action approuvée et exécutée",
      "rejected_success": "Action rejetée",
      "expires_in": "Expire dans {{time}}",
      "expired": "Expirée",
      "maker": "Demandeur",
      "action": "Action",
      "affected": "Produits concernés"
    },
    "table": {
      "presence_editing": "{{name}} est en train de modifier ce produit",
      "realtime_updated": "Mis à jour par {{name}}",
      "sort_asc": "Trier par ordre croissant",
      "sort_desc": "Trier par ordre décroissant"
    },
    "error_boundary": {
      "title": "Erreur inattendue",
      "message": "Un problème est survenu lors du chargement des produits.",
      "retry": "Réessayer",
      "report": "Signaler le problème"
    }
  }
}
